import { InfoBox, Loader } from "@tfg/ui"
import { createContext, PropsWithChildren, useCallback, useState } from "react"
import { useTranslation } from "react-i18next"

import {
  FindAllActivitiesResponseDto,
  FindOperationChainsResponseDto,
} from "~/gen/api"
import { useOpChainsQueries } from "~/pages/Admin/Ingestion/OpChains/store/useOpChainsQueries"

type OperationChainContext = {
  opChainIdSelected: string | null
  openOpChainManagementContainer: (id: string) => void
  activities: FindAllActivitiesResponseDto[]
  operationChains: FindOperationChainsResponseDto[]
}

export const OpChainContext = createContext<OperationChainContext>({
  opChainIdSelected: null,
  openOpChainManagementContainer: () => void {},
  activities: [],
  operationChains: [],
})

type Props = PropsWithChildren<object>

export function OpChainContextProvider({ children }: Props) {
  const [opChainIdSelected, setOpChainIdSelected] = useState<string | null>(
    null
  )
  const { t } = useTranslation()

  const { isLoading, isError, activities, opChains } = useOpChainsQueries()

  const openOpChainManagementContainer = useCallback((id: string) => {
    setOpChainIdSelected(id)
  }, [])

  if (isLoading) {
    return <Loader fullPage />
  }

  if (isError) {
    return (
      <InfoBox
        title={t("dataLoad.noResults.title")}
        message={t("dataLoad.noResults.message")}
      />
    )
  }

  const value: OperationChainContext = {
    opChainIdSelected,
    openOpChainManagementContainer,
    activities: activities?.data ?? [],
    operationChains: opChains?.data ?? [],
  }

  return (
    <OpChainContext.Provider value={value}>{children}</OpChainContext.Provider>
  )
}
